$(function () {
	$('[data-toggle="tab"]').each(function () {
		const $this = $(this);
		const $tabContainer = $this.data("target");
		$this.tabslet({
			container: $tabContainer,
		});
	});
});
// .main-tabslet(data-toggle="tab" data-target="#tabContainer")
// 	ul
// 		li
// 			a(href="#tab-1") Tab 1
// 		li
// 			a(href="#tab-2") Tab 2
// #tabContainer
// 	.tab-content#tab-1
// 	.tab-content#tab-2
